<template>
  <div>
    <!-- カバー -->
    <TeCounselingCover />

    <!-- Amazonギフトカード -->
    <TeCounselingAmazonGiftNew />

    <TeCounselingAboutTechAcademyAnniversary />

    <!-- こんな話が聞けます -->
    <TeCounselingQuestion>
      <template #discountText>
        <div class="mt-5 flex items-center justify-center">
          <p class="font-bold">
            ちょこっと説明が聞きたい、質問したいという方も、お気軽にご参加ください♪
          </p>
        </div>
      </template>
    </TeCounselingQuestion>

    <!-- 女性訴求 -->
    <TeCounselingWoman />

    <TeCounselingStep />
    <TeCounselingReviewsTwitter />
    <TeCounselingNeeds />
    <TeCounselingFaq />
    <TeCounselingAmazonGift />
    <TeCounselingApplyMatching />
    <TeCounselingButtonFixed />
  </div>
</template>

<script setup lang="ts">
import { useCounselingHead } from '~/composables/head/useCounselingHead'

import TeCounselingCover from '~/components/Te/TeCounseling/TeCounselingCover.vue'
import TeCounselingAmazonGiftNew from '~/components/Te/TeCounseling/TeCounselingAmazonGiftNew.vue'
import TeCounselingAboutTechAcademyAnniversary from '~/components/Te/TeCounseling/TeCounselingAboutTechAcademyAnniversary.vue'
import TeCounselingQuestion from '~/components/Te/TeCounseling/TeCounselingQuestion.vue'
import TeCounselingWoman from '~/components/Te/TeCounseling/TeCounselingWoman.vue'
import TeCounselingStep from '~/components/Te/TeCounseling/TeCounselingStep.vue'
import TeCounselingReviewsTwitter from '~/components/Te/TeCounseling/TeCounselingReviewsTwitter.vue'
import TeCounselingNeeds from '~/components/Te/TeCounseling/TeCounselingNeeds.vue'
import TeCounselingFaq from '~/components/Te/TeCounseling/TeCounselingFaq.vue'
import TeCounselingAmazonGift from '~/components/Te/TeCounseling/TeCounselingAmazonGift.vue'
import TeCounselingApplyMatching from '~/components/Te/TeCounseling/Apply/TeCounselingApplyMatching.vue'
import TeCounselingButtonFixed from '~/components/Te/TeCounseling/TeCounselingButtonFixed.vue'

useCounselingHead()

</script>
